import styled from "styled-components"

export default styled.p`
  font-family: var(--font-family-secondary);
  font-weight: var(--font-weight-regular);
  font-size: ${18 / 16}rem;
`
